// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-location-info[data-v-5ca34550]{border:2px solid #eaeaea;border-radius:10px;box-shadow:0 2px 2px 0 rgba(0,0,0,.04)!important}.single-line[data-v-5ca34550]{max-width:218px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
